export const SECTION_CARD_SX = {
  backgroundColor: "white",
  borderRadius: "12px",
  border: "1px solid rgba(226, 232, 240, 0.76)",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05), 0 1px 4px rgba(0,0,0,0.04)",
  overflow: "hidden",
  transition: "box-shadow 0.25s ease",
  "&:hover": {
    boxShadow: "0 8px 30px rgba(0,0,0,0.09), 0 2px 6px rgba(0,0,0,0.05)",
  },
};
